export const environment = {
  production: false,
  apiUrl: 'https://api20220615202555.azurewebsites.net',
  // apiUrl: 'https://localhost:44320',
  envName: 'local'
};

